import { css } from '@/styled-system/css';

export const floatingActionButtonStyles = css({
  position: 'fixed',
  zIndex: 'zIndexOverParent',
  width: '66px',
  height: '66px',
  borderRadius: '60px',
  boxShadow: '1px 1px 2px {colors.hpxGrey600}',
  border: 'none',
  backgroundColor: '{colors.hpxTeal500}',
  color: '{colors.hpxWhite}',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transitionProperty: 'all',
  transitionDuration: '0.15s',
  transitionTimingFunction: 'ease-in-out',
  userSelect: 'none',

  '&:focus': {
    backgroundColor: '{colors.hpxTeal600}',
    outline: 'none',
  },

  '&:hover': {
    backgroundColor: '{colors.hpxTeal600}',
  },

  '&:active, &.active': {
    backgroundColor: '{colors.hpxTeal700}',
  },

  '&:disabled': {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
});
